 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Collections-bau-page~Collections-bus-RFD-page~Collections-bus-page~collections-page":"Collections-bau-page~Collections-bus-RFD-page~Collections-bus-page~collections-page","Collections-bau-page":"Collections-bau-page","Collections-bus-RFD-page":"Collections-bus-RFD-page","Collections-bus-page":"Collections-bus-page","collections-page":"collections-page","Collections-bus-employment-page~Collections-employment-page":"Collections-bus-employment-page~Collections-employment-page","Collections-bus-employment-page":"Collections-bus-employment-page","Collections-employment-page":"Collections-employment-page","Financial-circumstances-page":"Financial-circumstances-page","Household-composition-page":"Household-composition-page","IE-method-page":"IE-method-page","Income-page":"Income-page","Monthly-expenditure-page":"Monthly-expenditure-page","address-page~applyplus-page~dyn-page~register-page~strategy-form-page":"address-page~applyplus-page~dyn-page~register-page~strategy-form-page","address-page":"address-page","applyplus-page":"applyplus-page","dyn-page":"dyn-page","register-page":"register-page","connect-page":"connect-page","consent-page~modal.deny~reconsent-page":"consent-page~modal.deny~reconsent-page","consent-page":"consent-page","modal.deny":"modal.deny","reconsent-page":"reconsent-page","customer-reference":"customer-reference","mastercard-page":"mastercard-page","mastercard-redirect~progress-page":"mastercard-redirect~progress-page","mastercard-redirect":"mastercard-redirect","progress-page":"progress-page","modal.NoBankAlert":"modal.NoBankAlert","modal.aboutAccountScore":"modal.aboutAccountScore","modal.faq":"modal.faq","modal.isSafe":"modal.isSafe","modal.noCreditImpact":"modal.noCreditImpact","modal.notice":"modal.notice","modal.policy":"modal.policy","modal.providingYoubankDetails":"modal.providingYoubankDetails","modal.security":"modal.security","modal.terms":"modal.terms","modal.whatIsOpenBanking":"modal.whatIsOpenBanking","modal.whoIsAccountscore":"modal.whoIsAccountscore","strategy-page":"strategy-page","systembuttons":"systembuttons","systempages":"systempages","validisdata-page":"validisdata-page","welcome-page":"welcome-page","pdfjsWorker":"pdfjsWorker","strategy-form-page":"strategy-form-page"}[chunkId]||chunkId) + "." + {"Collections-bau-page~Collections-bus-RFD-page~Collections-bus-page~collections-page":"c757bd8e","Collections-bau-page":"68d359f4","Collections-bus-RFD-page":"80ace11b","Collections-bus-page":"763c7a3a","collections-page":"1d725841","Collections-bus-employment-page~Collections-employment-page":"a1fd8dc3","Collections-bus-employment-page":"5e990dc8","Collections-employment-page":"c87d5f94","Financial-circumstances-page":"5202d191","Household-composition-page":"6d8a3642","IE-method-page":"f82bd0a3","Income-page":"367114cb","Monthly-expenditure-page":"6faf1bf9","address-page~applyplus-page~dyn-page~register-page~strategy-form-page":"b327f5af","address-page":"13462465","applyplus-page":"f2a89e22","dyn-page":"2afebb27","register-page":"f508172f","chunk-077eaa58":"95095504","chunk-2ff881f4":"1dfbdb41","chunk-517146cf":"1a1e4946","chunk-5a7ab60a":"9e6dd647","chunk-64b33d7c":"b25e4542","chunk-7b43f4b2":"88b5e483","chunk-a146fcb8":"2cc42742","chunk-b12195a6":"aa823bda","chunk-c53bc6a8":"e433812b","chunk-d8e34d3c":"804251f1","chunk-dd079f84":"fecb86d8","connect-page":"09cee2e3","consent-page~modal.deny~reconsent-page":"cb158cf3","consent-page":"cad7f252","modal.deny":"7596d9d8","reconsent-page":"dd35bb4d","customer-reference":"999e40f2","mastercard-page":"f68a98f0","mastercard-redirect~progress-page":"4f4e60a3","mastercard-redirect":"f324a91e","progress-page":"b78183f0","modal.NoBankAlert":"f56fe761","modal.aboutAccountScore":"77c11d88","modal.faq":"65cebc42","modal.isSafe":"e483371e","modal.noCreditImpact":"582f451f","modal.notice":"38d6796c","modal.policy":"433425dd","modal.providingYoubankDetails":"3f6b1a64","modal.security":"8a0f481e","modal.terms":"88d60790","modal.whatIsOpenBanking":"a1171118","modal.whoIsAccountscore":"d333ab02","strategy-page":"e3a21fe2","systembuttons":"da7cf891","systempages":"02876bbe","validisdata-page":"69e10d10","welcome-page":"da5927c0","chunk-545924dd":"06cf1dda","pdfjsWorker":"36362239","chunk-5b6d8372":"edac310e","chunk-2d0aad88":"deafcb79","chunk-2d0af25f":"f53d0a80","chunk-2d0ba548":"27e18ebb","chunk-2d0bd3c8":"cd261605","chunk-2d0c7793":"c264e1a4","chunk-2d0c959a":"54fe6c22","chunk-2d0ced27":"97f8f21f","chunk-2d0ced60":"a0ca2d85","chunk-2d0cf8d2":"bfa497d3","chunk-2d0d6be0":"089e572b","chunk-2d0dd82e":"9cfc48e1","chunk-2d0def1f":"b18caea5","chunk-2d0e91cd":"581f6714","chunk-2d20f71b":"1bda36a5","chunk-2d21447b":"e4678d60","chunk-2d21aeaa":"e928cf15","chunk-2d21b23f":"a9cc213e","chunk-2d21b26d":"b1fe1f89","chunk-2d21d8af":"d0411c2b","chunk-2d22566f":"436b75e4","chunk-2d225fe6":"0df8bbd7","chunk-2d0ae919":"897bf587","chunk-2d0b61aa":"b906be05","chunk-2d0c2633":"b6ef63bd","chunk-2d0d2f25":"dfc067d7","chunk-2d0d83e8":"16762beb","chunk-2d0dab42":"2a7bf914","chunk-2d0e28a9":"aaf20c7f","chunk-2d0e59a2":"2a2ec2b6","chunk-2d0e66f2":"e27f53f5","chunk-2d0e961f":"68fdbb9f","chunk-2d207da4":"c4e5faf9","chunk-2d20ef4b":"99cfd3c0","chunk-2d21b4cc":"e6b58f4d","chunk-2d221c38":"0ca0b0df","chunk-2d22ce59":"c7e89600","chunk-2d230864":"3ecd129a","chunk-772305bb":"850087e8","strategy-form-page":"477a757a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Collections-bau-page~Collections-bus-RFD-page~Collections-bus-page~collections-page":1,"Collections-bau-page":1,"Collections-bus-RFD-page":1,"Collections-bus-page":1,"collections-page":1,"Collections-bus-employment-page~Collections-employment-page":1,"Collections-bus-employment-page":1,"Collections-employment-page":1,"Financial-circumstances-page":1,"Household-composition-page":1,"IE-method-page":1,"Income-page":1,"Monthly-expenditure-page":1,"address-page~applyplus-page~dyn-page~register-page~strategy-form-page":1,"address-page":1,"applyplus-page":1,"chunk-077eaa58":1,"chunk-2ff881f4":1,"chunk-517146cf":1,"chunk-5a7ab60a":1,"chunk-64b33d7c":1,"chunk-7b43f4b2":1,"chunk-a146fcb8":1,"chunk-b12195a6":1,"chunk-c53bc6a8":1,"chunk-d8e34d3c":1,"chunk-dd079f84":1,"connect-page":1,"consent-page~modal.deny~reconsent-page":1,"consent-page":1,"modal.deny":1,"reconsent-page":1,"customer-reference":1,"mastercard-page":1,"mastercard-redirect~progress-page":1,"mastercard-redirect":1,"progress-page":1,"modal.NoBankAlert":1,"modal.aboutAccountScore":1,"modal.faq":1,"modal.isSafe":1,"modal.noCreditImpact":1,"modal.notice":1,"modal.policy":1,"modal.providingYoubankDetails":1,"modal.security":1,"modal.terms":1,"modal.whatIsOpenBanking":1,"modal.whoIsAccountscore":1,"strategy-page":1,"systembuttons":1,"systempages":1,"validisdata-page":1,"welcome-page":1,"chunk-545924dd":1,"chunk-5b6d8372":1,"strategy-form-page":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Collections-bau-page~Collections-bus-RFD-page~Collections-bus-page~collections-page":"Collections-bau-page~Collections-bus-RFD-page~Collections-bus-page~collections-page","Collections-bau-page":"Collections-bau-page","Collections-bus-RFD-page":"Collections-bus-RFD-page","Collections-bus-page":"Collections-bus-page","collections-page":"collections-page","Collections-bus-employment-page~Collections-employment-page":"Collections-bus-employment-page~Collections-employment-page","Collections-bus-employment-page":"Collections-bus-employment-page","Collections-employment-page":"Collections-employment-page","Financial-circumstances-page":"Financial-circumstances-page","Household-composition-page":"Household-composition-page","IE-method-page":"IE-method-page","Income-page":"Income-page","Monthly-expenditure-page":"Monthly-expenditure-page","address-page~applyplus-page~dyn-page~register-page~strategy-form-page":"address-page~applyplus-page~dyn-page~register-page~strategy-form-page","address-page":"address-page","applyplus-page":"applyplus-page","dyn-page":"dyn-page","register-page":"register-page","connect-page":"connect-page","consent-page~modal.deny~reconsent-page":"consent-page~modal.deny~reconsent-page","consent-page":"consent-page","modal.deny":"modal.deny","reconsent-page":"reconsent-page","customer-reference":"customer-reference","mastercard-page":"mastercard-page","mastercard-redirect~progress-page":"mastercard-redirect~progress-page","mastercard-redirect":"mastercard-redirect","progress-page":"progress-page","modal.NoBankAlert":"modal.NoBankAlert","modal.aboutAccountScore":"modal.aboutAccountScore","modal.faq":"modal.faq","modal.isSafe":"modal.isSafe","modal.noCreditImpact":"modal.noCreditImpact","modal.notice":"modal.notice","modal.policy":"modal.policy","modal.providingYoubankDetails":"modal.providingYoubankDetails","modal.security":"modal.security","modal.terms":"modal.terms","modal.whatIsOpenBanking":"modal.whatIsOpenBanking","modal.whoIsAccountscore":"modal.whoIsAccountscore","strategy-page":"strategy-page","systembuttons":"systembuttons","systempages":"systempages","validisdata-page":"validisdata-page","welcome-page":"welcome-page","pdfjsWorker":"pdfjsWorker","strategy-form-page":"strategy-form-page"}[chunkId]||chunkId) + "." + {"Collections-bau-page~Collections-bus-RFD-page~Collections-bus-page~collections-page":"6a1c86c9","Collections-bau-page":"856aac8b","Collections-bus-RFD-page":"53e291a4","Collections-bus-page":"2a3ba298","collections-page":"9c158649","Collections-bus-employment-page~Collections-employment-page":"88dad174","Collections-bus-employment-page":"34d85343","Collections-employment-page":"dcd3bc12","Financial-circumstances-page":"78c2e95e","Household-composition-page":"1ad49866","IE-method-page":"b6d5a148","Income-page":"c6b19670","Monthly-expenditure-page":"c4a8e3d3","address-page~applyplus-page~dyn-page~register-page~strategy-form-page":"4b6f1a20","address-page":"13d1c843","applyplus-page":"7441125b","dyn-page":"31d6cfe0","register-page":"31d6cfe0","chunk-077eaa58":"2694166d","chunk-2ff881f4":"e343f0f5","chunk-517146cf":"cbc0d992","chunk-5a7ab60a":"cf588a52","chunk-64b33d7c":"8e690fb3","chunk-7b43f4b2":"16c34bcb","chunk-a146fcb8":"bfc49956","chunk-b12195a6":"ad04e5bc","chunk-c53bc6a8":"02d2c700","chunk-d8e34d3c":"c63f6174","chunk-dd079f84":"cbc0d992","connect-page":"ed849610","consent-page~modal.deny~reconsent-page":"4b6f1a20","consent-page":"b866c903","modal.deny":"6ff5f950","reconsent-page":"fce389af","customer-reference":"ba63573d","mastercard-page":"4c92e276","mastercard-redirect~progress-page":"7078b30e","mastercard-redirect":"8b1d0215","progress-page":"57eb3f11","modal.NoBankAlert":"483e8ca7","modal.aboutAccountScore":"39e326c3","modal.faq":"b7120810","modal.isSafe":"11663273","modal.noCreditImpact":"39e326c3","modal.notice":"e86ab936","modal.policy":"7f699b58","modal.providingYoubankDetails":"39e326c3","modal.security":"39e326c3","modal.terms":"383abfc0","modal.whatIsOpenBanking":"8da6ed91","modal.whoIsAccountscore":"02c2aaa6","strategy-page":"323b07d4","systembuttons":"53c9163c","systempages":"772fb531","validisdata-page":"fa7f0c8f","welcome-page":"bdb46126","chunk-545924dd":"25df017f","pdfjsWorker":"31d6cfe0","chunk-5b6d8372":"6032ef09","chunk-2d0aad88":"31d6cfe0","chunk-2d0af25f":"31d6cfe0","chunk-2d0ba548":"31d6cfe0","chunk-2d0bd3c8":"31d6cfe0","chunk-2d0c7793":"31d6cfe0","chunk-2d0c959a":"31d6cfe0","chunk-2d0ced27":"31d6cfe0","chunk-2d0ced60":"31d6cfe0","chunk-2d0cf8d2":"31d6cfe0","chunk-2d0d6be0":"31d6cfe0","chunk-2d0dd82e":"31d6cfe0","chunk-2d0def1f":"31d6cfe0","chunk-2d0e91cd":"31d6cfe0","chunk-2d20f71b":"31d6cfe0","chunk-2d21447b":"31d6cfe0","chunk-2d21aeaa":"31d6cfe0","chunk-2d21b23f":"31d6cfe0","chunk-2d21b26d":"31d6cfe0","chunk-2d21d8af":"31d6cfe0","chunk-2d22566f":"31d6cfe0","chunk-2d225fe6":"31d6cfe0","chunk-2d0ae919":"31d6cfe0","chunk-2d0b61aa":"31d6cfe0","chunk-2d0c2633":"31d6cfe0","chunk-2d0d2f25":"31d6cfe0","chunk-2d0d83e8":"31d6cfe0","chunk-2d0dab42":"31d6cfe0","chunk-2d0e28a9":"31d6cfe0","chunk-2d0e59a2":"31d6cfe0","chunk-2d0e66f2":"31d6cfe0","chunk-2d0e961f":"31d6cfe0","chunk-2d207da4":"31d6cfe0","chunk-2d20ef4b":"31d6cfe0","chunk-2d21b4cc":"31d6cfe0","chunk-2d221c38":"31d6cfe0","chunk-2d22ce59":"31d6cfe0","chunk-2d230864":"31d6cfe0","chunk-772305bb":"31d6cfe0","strategy-form-page":"05d89f4e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["modal.NoBankAlert","modal.aboutAccountScore","modal.faq","modal.isSafe","modal.noCreditImpact","modal.notice","modal.policy","modal.providingYoubankDetails","modal.security","modal.terms","modal.whatIsOpenBanking","modal.whoIsAccountscore"]]);
 	return startupResult;
